import {FixMeAny} from 'types'

import * as EE from 'events'

const reportError = require('airship/modules/error-reporting')

const ARROW_WIDTH = 10
const ARROW_HEIGHT = 5

export class Popover extends EE {
  public el: JQuery<HTMLElement>
  public node: FixMeAny
  public is_open: boolean
  private attached_el: FixMeAny
  private attach_top: boolean

  public constructor({attachTop = false, className = 'popover'} = {}) {
    super()
    const el = $('<div>').addClass(className)
    $(document.body).append(el)

    this.on('error', (err: Error) => reportError(err, __filename))

    this.attached_el = null
    this.is_open = false
    this.el = el
    this.node = el[0]
    this.attach_top = attachTop

    this.outsideClickHandler = this.outsideClickHandler.bind(this)
    this.resizeHandler = this.resizeHandler.bind(this)
    this.keyupHandler = this.keyupHandler.bind(this)
  }

  public open(_el: Element): void {
    const el = $(_el)

    this.el.show()
    this.attached_el = el
    this.setPosition(this.attached_el)
    this.is_open = true

    window.addEventListener('resize', this.resizeHandler)

    // prevents outside click handler from closing popover early if it was opened
    // as the result of a click
    process.nextTick(() => {
      document.addEventListener('keyup', this.keyupHandler)
      document.addEventListener('click', this.outsideClickHandler)
    })

    this.emit('open', el)
  }

  public close(): void {
    if (!this.is_open) {
      return
    }

    this.el.hide()
    this.attached_el = null
    this.is_open = false

    window.removeEventListener('resize', this.resizeHandler)

    process.nextTick(() => {
      document.removeEventListener('keyup', this.keyupHandler)
      document.removeEventListener('click', this.outsideClickHandler)
    })

    this.emit('close')
  }

  public end(): void {
    this.close()
    this.teardown()
    this.el.remove()
  }

  protected teardown(): void {
    return
  }

  protected setArrowOverrideLeft(offset: number): void {
    this.attached_el.find('[rel="arrow"]').css({
      left: offset
    })
  }

  private setPosition(_el: HTMLElement): void {
    const el = $(_el)
    const windowWidth = $('body').outerWidth() || 0
    const popoverWidth = this.el.outerWidth() || 0
    const targetWidth = el.outerWidth() || 0

    const offset = el.offset() || {left: 0, top: 0}
    let offsetLeft =
      offset.left - Math.floor(popoverWidth / 2) + Math.floor(targetWidth / 2)

    if (windowWidth && popoverWidth + offsetLeft > windowWidth) {
      const previousLeft = offsetLeft
      offsetLeft = windowWidth - popoverWidth

      this.setArrowOverrideLeft(previousLeft - offsetLeft - ARROW_WIDTH / 2)
    } else if (offsetLeft < ARROW_WIDTH) {
      offsetLeft = ARROW_WIDTH
    }

    const offsetTop = this.attach_top
      ? offset.top - (this.el.outerHeight() || 0) - ARROW_HEIGHT
      : offset.top + (el.outerHeight() || 0) + ARROW_HEIGHT

    this.el.css({
      left: `${offsetLeft}px`,
      top: `${offsetTop}px`,
      position: 'absolute'
    })
  }

  private resizeHandler(): void {
    if (this.is_open) {
      this.setPosition(this.attached_el)
    }
  }

  private keyupHandler(ev: KeyboardEvent): void {
    if (ev.key === 'Escape') {
      this.close()
    }
  }

  private outsideClickHandler(ev: MouseEvent): void {
    const inPopover = this.node.contains(ev.target)
    if (!inPopover) {
      this.close()
    }
  }
}
